var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 14,
    viewBox: "0 0 20 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "email"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M1.35103 0.0557804C1.02304 0.137416 0.77704 0.277364 0.527138 0.526159C0.273331 0.778842 0.117142 1.05485 0.0468567 1.39306C-0.0156189 1.6885 -0.0156189 12.3167 0.0468567 12.6044C0.191332 13.2692 0.737993 13.8134 1.4018 13.9534C1.69465 14.0155 18.3053 14.0155 18.5982 13.9534C19.262 13.8134 19.8126 13.2614 19.9531 12.6044C20.0156 12.309 20.0156 1.68073 19.9531 1.39306C19.8087 0.724419 19.2659 0.184065 18.5982 0.0441179C18.2819 -0.0219688 1.61656 -0.0103064 1.35103 0.0557804ZM14.1976 4.94228C12.1125 7.01428 10.3631 8.7403 10.3046 8.7714C10.1679 8.84138 9.8321 8.84138 9.69543 8.7714C9.63686 8.7403 7.88754 7.01428 5.80242 4.94228L2.01484 1.16759H10H17.9852L14.1976 4.94228ZM3.70168 9.5139L1.17532 12.033V6.99873V1.96451L3.70168 4.48357L6.23194 6.99873L3.70168 9.5139ZM18.8247 7.00651V12.033L16.2983 9.51779L13.7681 6.99873L16.2866 4.49134C17.6728 3.1113 18.8091 1.98395 18.813 1.98395C18.8208 1.98395 18.8247 4.24643 18.8247 7.00651ZM7.96564 8.75974C8.80515 9.58776 8.91449 9.68106 9.19563 9.82101L9.50801 9.97262H9.9961C10.4842 9.97262 10.492 9.97262 10.7966 9.8249C11.0816 9.68884 11.1714 9.61109 12.0383 8.75974L12.9715 7.83842L15.4783 10.3342L17.9852 12.8299H10H2.01484L4.51386 10.3419C5.88832 8.97355 7.0207 7.85397 7.0285 7.85397C7.04022 7.85397 7.46193 8.26215 7.96564 8.75974Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.c2cd94825b78144dad5201241e35883c.svg";
export { ForwardRef as ReactComponent };